import { LTLQuickQuoteRequest } from 'lib/api/getLTLQuickQuotes';
import { Maybe } from 'types/UtilityTypes';

import {
  LTLCustomerData,
  LTLCustomerStaffData,
  buildLTLTaiRequest,
} from '../../LTL/api/buildLTLTaiRequest';
import type { HeightConfig } from '../../utils/ltlMetrics';
import { normalizeStopsFromLocationLine } from '../../utils/parseStopAddressFromLocation';
import { BatchLTLShipmentInput } from '../types';

type BatchLTLRequestContext = {
  ltlCustomer: Maybe<LTLCustomerData>;
  ltlCustomerStaff: Maybe<LTLCustomerStaffData>;
  emailId: number;
  threadId: string;
  // The same cubic feet height override the single form sends.
  cubicFeetCalculationConfig?: HeightConfig;
};

// The same Tai LTL request the single form sends, for one shipment of the batch.
export function buildBatchLTLShipmentRequest(
  shipment: BatchLTLShipmentInput,
  {
    ltlCustomer,
    ltlCustomerStaff,
    emailId,
    threadId,
    cubicFeetCalculationConfig,
  }: BatchLTLRequestContext
): LTLQuickQuoteRequest {
  return buildLTLTaiRequest(
    {
      ...shipment,
      customerName: ltlCustomer?.customerId ?? shipment.customerName,
      stops: normalizeStopsFromLocationLine(shipment.stops),
    },
    ltlCustomer,
    ltlCustomerStaff,
    shipment.quoteRequestId,
    emailId,
    threadId,
    cubicFeetCalculationConfig,
    true
  );
}
